module.exports = __webpack_public_path__ + "img/bridge-fee-Fetesti.0e479eac.svg";